import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../../common.service';
import Utils from '../../../utils';
import {
  Router, NavigationEnd
} from '@angular/router';
import {
  GlobalSettings
} from '../../../global.settings';

@Component({
  selector: 'app-adv-search-taxonomy-listing',
  templateUrl: './adv-search-taxonomy-listing.component.html',
  styleUrls: ['./adv-search-taxonomy-listing.component.scss']
})
export class AdvSearchTaxonomyListingComponent implements OnInit {
  @Input() advSearchlist;
  @Input() itemsResponse;
  @Input() documentIds;
  @Input() allListValueCount;
  @Output() sortDatalistEvent: EventEmitter<any>;
  showLoaderAdvsearch = true;
  allSourceData: any[] = [];
  startIndex : any;
  lastIndex : any;
  pageIndex = -1; 
  pagination: any = {
    start: 0,
    last: Utils.PAGINATION_LOWER_LIMIT,
    pageIndex: 1,
    itemPerPage: Utils.PAGINATION_LOWER_LIMIT
  };
  itemsCount:any;
  noDataItem = false;
  itemsPerPage:any;

  constructor(private service: CommonService, private router: Router) { 
    this.sortDatalistEvent = new EventEmitter<any>();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {

    if(changes.advSearchlist.currentValue != null){
      this.allSourceData = changes.advSearchlist.currentValue
      this.itemsPerPage = this.itemsPerPage;
      //this.updateHtmlData();
      this.showLoaderAdvsearch = false;
    }

  }

  showDataInRange(event){
    this.itemsPerPage = event.itemPerPage;
    this.startIndex = event.start - 1;
    this.lastIndex = event.last;
    this.pageIndex = event.pageIndex;
    if (this.pageIndex == 2 && event.mode == 'next' && !this.noDataItem && this.itemsResponse.org_id != undefined){
      this.showLoaderAdvsearch = true;
      this.nextResponse(this.pageIndex);
      this. pagination = 'fromAdvTaxonomylisting'
    }
    else if(this.pageIndex > 2 && event.mode == 'next' && !this.noDataItem && this.itemsResponse.org_id != undefined){
      this.showLoaderAdvsearch = true;
      this.nextResponse(this.pageIndex);
      this. pagination = 'fromAdvTaxonomylisting'
    }
    if(event.mode == 'previous'){
      this.showLoaderAdvsearch = true;
      if(this.itemsCount<this.itemsPerPage){
        this.itemsCount = 0;
        this.previousResponse(this.itemsCount)
      }
      else{
        this.itemsCount=this.itemsCount - this.itemsPerPage;
        this.previousResponse(this.itemsCount)
      }
      
    }
    else if(event.mode == 'updatePagination' && this.itemsResponse.org_id != undefined){
      this.showLoaderAdvsearch = true;
      this.fnUpdatePagination();
    }
  }
  nextResponse(pageIndex){

    let bodyItems;
    if(pageIndex == 2){
      if(this.itemsCount == undefined){
        this.itemsCount = this.itemsResponse.size;
      }
      bodyItems = {
        "start": this.itemsCount ,//this.itemsResponse.size,
        "size":  this.itemsPerPage ,
        "hasProject": false,
        "index": "cfitems",
        "search_match": {},
        "org_id": this.itemsResponse.org_id,
        "search_filter": this.itemsResponse.search_filter,
        "response": [],
        "unique_search": {},
        "collapse": "",
        "front_facing": true,
        "organization_id": this.itemsResponse.org_id,
      };
      //this.itemsCount = this.itemsResponse.size
    }
    else if(pageIndex > 2){
      const itemsCount = this.itemsCount + this.itemsPerPage
      bodyItems = {
        "start": itemsCount,
        "size": this.itemsPerPage ,
        "hasProject": false,
        "index": "cfitems",
        "search_match": {},
        "org_id": this.itemsResponse.org_id,
        "search_filter": this.itemsResponse.search_filter,
        "response": [],
        "unique_search": {},
        "collapse": "",
        "front_facing": true,
        "organization_id": this.itemsResponse.org_id
      };
      this.itemsCount = itemsCount;
    }

  const url = GlobalSettings.ELASTIC_SEARCH;
    this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyItems).then((itemsResponse: any) => {
      if(itemsResponse.data.hits.hits.length == 0){
        this.noDataItem = true;   
      }
      this.allSourceData = this.allSourceData.concat(itemsResponse.data.hits.hits);
      this.sortDatalistEvent.emit(this.allSourceData);
      //this.updateHtmlData();
      this.showLoaderAdvsearch = false;
      },
      error => {
        // Handle errors
      });
  }
  
  previousResponse(count){
    if(count == 0){
      const url = GlobalSettings.ELASTIC_SEARCH + '?front_facing=' + true + '&organization_id=' + this.itemsResponse.org_id;
      let bodyDocument =   {
        "start": count,
        "size": this.itemsPerPage,
        "hasProject": false,
        "index": "cfdocument",
        "search_match": {},
        "org_id": this.itemsResponse.org_id,
        "search_filter": [
          { "title" : this.itemsResponse.search_filter[0].fullStatement,
            "course_description": this.itemsResponse.search_filter[0].fullStatement
           },
           {"document_id.keyword": this.documentIds}
      ],
        "response": [],
        "unique_search": {},
        "collapse": "",
        "front_facing": true,
        "organization_id": this.itemsResponse.org_id
      };
  
      this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyDocument).then((documentsResponse: any) => {
            const documentsCount = documentsResponse.data.hits.total.value;
            const documentArrCount = documentsResponse.data.hits ? documentsResponse.data.hits.hits.length :0;
              let bodyItems = {
                "start": count,
                "size": this.itemsPerPage-documentArrCount ,
                "hasProject": false,
                "index": "cfitems",
                "search_match": {},
                "org_id": this.itemsResponse.org_id,
                "search_filter": [
                  {
                    "fullStatement": this.itemsResponse.search_filter[0].fullStatement,
                    "humanCodingScheme": this.itemsResponse.search_filter[0].fullStatement,
                    "course_description": this.itemsResponse.search_filter[0].fullStatement
                  },
                  {"document_id.keyword": this.documentIds}
                ],
                "response": [],
                "unique_search": {},
                "collapse": "",
                "front_facing": true,
                "organization_id": this.itemsResponse.org_id
              };
              this.itemsCount = this.itemsPerPage-documentArrCount ;
              this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyItems).then((itemsResponse: any) => {
                    this.allSourceData = documentsResponse.data.hits.hits.concat(itemsResponse.data.hits.hits);
                    this.allListValueCount = documentsCount+(itemsResponse.data.hits.total.value);
                    this.sortDatalistEvent.emit(this.allSourceData);
                    this.showLoaderAdvsearch = false;
                  },
                  error => {
                    // Handle errors
                  }
                );
          },
          error => {
            // Handle errors
          }
        );
    }
    else{
      let bodyItems = {
        "start": count,
        "size": this.itemsPerPage ,
        "hasProject": false,
        "index": "cfitems",
        "search_match": {},
        "org_id": this.itemsResponse.org_id,
        "search_filter": this.itemsResponse.search_filter,
        "response": [],
        "unique_search": {},
        "collapse": "",
        "front_facing": true,
        "organization_id": this.itemsResponse.org_id
      };
      const url = GlobalSettings.ELASTIC_SEARCH + '?front_facing=' + true + '&organization_id=' + this.itemsResponse.org_id;
      this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyItems).then((itemsResponse: any) => {
        if(itemsResponse.data.hits.hits.length == 0){
          this.noDataItem = true;   
        }
        this.allSourceData = this.allSourceData.concat(itemsResponse.data.hits.hits);
        this.sortDatalistEvent.emit(this.allSourceData);
        //this.updateHtmlData();
        this.showLoaderAdvsearch = false;
        },
        error => {
          // Handle errors
        });
    }
  }

  onTaxonomyDetailItem(product){
    let path = '';
    if(product._source.item_id){
        path = this.service.getOrgDetails() + '/' + Utils.ROUTE_FRONT_FACE_TAXONOMY_DETAIL + '/' + product._source.document_id + '/' + product._source.item_id;
    }
    else{
        path = this.service.getOrgDetails() + '/' + Utils.ROUTE_FRONT_FACE_TAXONOMY_DETAIL + '/' + product._source.document_id + '?adv=true';
    }
    this.router.navigate([]).then((r)=>{
          window.open(GlobalSettings.PRODUCT_NAME + '#' +path, '_blank');
    });
  }

  onTaxonomtDetail(product){
    const path = this.service.getOrgDetails() + '/' + Utils.ROUTE_FRONT_FACE_TAXONOMY_DETAIL + '/' + product._source.document_id + '?adv=true';
    this.router.navigate([]).then((r)=>{
      window.open(GlobalSettings.PRODUCT_NAME + '#' +path, '_blank');
    })
  }

  fnUpdatePagination(){
      let page=0;
      const url = GlobalSettings.ELASTIC_SEARCH + '?front_facing=' + true + '&organization_id=' + this.itemsResponse.org_id;
      let bodyDocument =   {
        "start": page,
        "size": this.itemsPerPage,
        "hasProject": false,
        "index": "cfdocument",
        "search_match": {},
        "org_id": this.itemsResponse.org_id,
        "search_filter": [
          { "title" : this.itemsResponse.search_filter[0].fullStatement,
            "course_description": this.itemsResponse.search_filter[0].fullStatement
           },
           {"document_id.keyword": this.documentIds}
      ],
        "response": [],
        "unique_search": {},
        "collapse": "",
        "front_facing": true,
        "organization_id": this.itemsResponse.org_id
      };
  
      this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyDocument).then((documentsResponse: any) => {
            const documentsCount = documentsResponse.data.hits.total.value;
            const documentArrCount = documentsResponse.data.hits ? documentsResponse.data.hits.hits.length :0;
              let bodyItems = {
                "start": page,
                "size": this.itemsPerPage-documentArrCount,
                "hasProject": false,
                "index": "cfitems",
                "search_match": {},
                "org_id": this.itemsResponse.org_id,
                "search_filter": [
                  {
                    "fullStatement": this.itemsResponse.search_filter[0].fullStatement,
                    "humanCodingScheme": this.itemsResponse.search_filter[0].fullStatement,
                    "course_description": this.itemsResponse.search_filter[0].fullStatement
                  },
                  {"document_id.keyword": this.documentIds}
                ],
                "response": [],
                "unique_search": {},
                "collapse": "",
                "front_facing": true,
                "organization_id": this.itemsResponse.org_id
              };
              this.itemsCount = this.itemsPerPage-documentArrCount ;
              this.service.getWithoutTockenAdvSearchFrontfacing(url,bodyItems).then((itemsResponse: any) => {
                    this.allSourceData = documentsResponse.data.hits.hits.concat(itemsResponse.data.hits.hits);
                    this.allListValueCount = documentsCount+(itemsResponse.data.hits.total.value);
                    this.sortDatalistEvent.emit(this.allSourceData);
                    this.showLoaderAdvsearch = false;
                  },
                  error => {
                    // Handle errors
                  }
                );
          },
          error => {
            // Handle errors
          }
        );
  }

  updateHtmlData() {
  for( let i=0 ; i< this.allSourceData.length; i++)
    {
      if(this.allSourceData[i]._index == 'cfitems'){
        this.allSourceData[i]._source.CFDocumentURI.title = Utils.extractContentFromHtml(this.allSourceData[i]._source.CFDocumentURI.title);
        this.allSourceData[i]._source.fullStatement = Utils.extractContentFromHtml(this.allSourceData[i]._source.fullStatement);
      }
     else{
      this.allSourceData[i]._source.title = Utils.extractContentFromHtml(this.allSourceData[i]._source.title);
      this.allSourceData[i]._source.description = Utils.extractContentFromHtml(this.allSourceData[i]._source.description);
     }
    }
  }

}
